// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as Char123LocaleChar125IndexRouteImport } from './routes/{-$locale}/index'
import { Route as Char123LocaleChar125CafeRouteImport } from './routes/{-$locale}/cafe'
import { Route as Char123LocaleChar125MeRouteImport } from './routes/{-$locale}/me'
import { Route as Char123LocaleChar125NotificationsRouteImport } from './routes/{-$locale}/notifications'
import { Route as Char123LocaleChar125PomodoroRouteImport } from './routes/{-$locale}/pomodoro'
import { Route as Char123LocaleChar125PrivacyRouteImport } from './routes/{-$locale}/privacy'
import { Route as Char123LocaleChar125RankingRouteImport } from './routes/{-$locale}/ranking'
import { Route as Char123LocaleChar125TermsRouteImport } from './routes/{-$locale}/terms'
import { Route as Char123LocaleChar125LogIdRouteImport } from './routes/{-$locale}/log/$id'
import { Route as Char123LocaleChar125UHandleRouteImport } from './routes/{-$locale}/u/$handle'

const Char123LocaleChar125IndexRoute = Char123LocaleChar125IndexRouteImport.update({
            id: '/{-$locale}/',path: '/{-$locale}/',getParentRoute: () => rootRouteImport
          })
const Char123LocaleChar125CafeRoute = Char123LocaleChar125CafeRouteImport.update({
            id: '/{-$locale}/cafe',path: '/{-$locale}/cafe',getParentRoute: () => rootRouteImport
          })
const Char123LocaleChar125MeRoute = Char123LocaleChar125MeRouteImport.update({
            id: '/{-$locale}/me',path: '/{-$locale}/me',getParentRoute: () => rootRouteImport
          })
const Char123LocaleChar125NotificationsRoute = Char123LocaleChar125NotificationsRouteImport.update({
            id: '/{-$locale}/notifications',path: '/{-$locale}/notifications',getParentRoute: () => rootRouteImport
          })
const Char123LocaleChar125PomodoroRoute = Char123LocaleChar125PomodoroRouteImport.update({
            id: '/{-$locale}/pomodoro',path: '/{-$locale}/pomodoro',getParentRoute: () => rootRouteImport
          })
const Char123LocaleChar125PrivacyRoute = Char123LocaleChar125PrivacyRouteImport.update({
            id: '/{-$locale}/privacy',path: '/{-$locale}/privacy',getParentRoute: () => rootRouteImport
          })
const Char123LocaleChar125RankingRoute = Char123LocaleChar125RankingRouteImport.update({
            id: '/{-$locale}/ranking',path: '/{-$locale}/ranking',getParentRoute: () => rootRouteImport
          })
const Char123LocaleChar125TermsRoute = Char123LocaleChar125TermsRouteImport.update({
            id: '/{-$locale}/terms',path: '/{-$locale}/terms',getParentRoute: () => rootRouteImport
          })
const Char123LocaleChar125LogIdRoute = Char123LocaleChar125LogIdRouteImport.update({
            id: '/{-$locale}/log/$id',path: '/{-$locale}/log/$id',getParentRoute: () => rootRouteImport
          })
const Char123LocaleChar125UHandleRoute = Char123LocaleChar125UHandleRouteImport.update({
            id: '/{-$locale}/u/$handle',path: '/{-$locale}/u/$handle',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  Char123LocaleChar125CafeRoute: Char123LocaleChar125CafeRoute,Char123LocaleChar125MeRoute: Char123LocaleChar125MeRoute,Char123LocaleChar125NotificationsRoute: Char123LocaleChar125NotificationsRoute,Char123LocaleChar125PomodoroRoute: Char123LocaleChar125PomodoroRoute,Char123LocaleChar125PrivacyRoute: Char123LocaleChar125PrivacyRoute,Char123LocaleChar125RankingRoute: Char123LocaleChar125RankingRoute,Char123LocaleChar125TermsRoute: Char123LocaleChar125TermsRoute,Char123LocaleChar125IndexRoute: Char123LocaleChar125IndexRoute,Char123LocaleChar125LogIdRoute: Char123LocaleChar125LogIdRoute,Char123LocaleChar125UHandleRoute: Char123LocaleChar125UHandleRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)